import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

const WatchlistsPanelSkeleton = ({ rows = 3 }) => {
  const { colors } = useTheme();

  return (
    <div style={{ padding: 12 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div 
          key={i} 
          style={{ 
            height: '32px', 
            backgroundColor: colors.borderLight, 
            borderRadius: '4px', 
            marginBottom: '8px',
            animation: 'pulse 1.5s ease-in-out infinite'
          }} 
        />
      ))}
    </div>
  );
};

export default WatchlistsPanelSkeleton;




